import FooterTextArea from "./text-area";
import classes from "./css/footer.module.css";
import DownTextFooter from "./down-textArea";
const MainFooter = () => {
  const upperTextFooter = "Have a project in mind?";
  const MainTextFooter = "LET'S WORK";
  const BottomTextArea = "BY Vivek Sharma";
  const currentYear = new Date().getFullYear();

  return (
    <>
      <div className={classes.footerComponent}>
        <div className={classes.footerTextComponent}>
          <FooterTextArea
            smallText={upperTextFooter}
            mainText={MainTextFooter}
          />
        </div>
        <div>
          <DownTextFooter signatureFooter={BottomTextArea} timestampFooter={currentYear}  />
        </div>
      </div>
    </>
  );
};

export default MainFooter;
